
import { Component, Vue } from "vue-property-decorator";
import Footer from "../../components/Footer.vue";
import HeaderLayout from "../Components/header.vue";
import MemberInfo from "./Modules/MemberInfo.vue";
import UploadProof from "./Modules/UploadProof.vue";
import Invoice from "./Modules/Invoice.vue";
import SelfInfo from "./Modules/SelfInfo.vue";

import Schedule from "./Modules/Schedule.vue";

import { IMeetingInfo, current } from "@/contants/current.ts";

@Component({
  components: {
    HeaderLayout,
    SelfInfo,
    MemberInfo,
    Invoice,
    UploadProof,
    Footer,
    Schedule,
  },
})
export default class PersonalCenter extends Vue {
  private flags: any = {
    showTab: 1,
    isLoading: true,
    is_fixed: false,
  };
  private current: any = {};
  private headData: any = {};
  private avatarUrl: string = "";
  private m: string = "";
  private meetingTitle: string = "欢迎您参加此次会议！";
  private signupUserInfo: any = {}; //当前登录的报名用户的信息
  private signDatas: any[] = []; //所有报名用户信息
  private memberdatas: any[] = []; //团员数据
  private upload_payorder = 0; //是否显示上传凭证
  private iswrite_invoice = 0; // 是否显示发票信息
  private allow_update_info = 0 //是否可修改
  private orderData: any = {}; //订单数据
  private subheading: string = "报名信息";
  private statusImgSrcList: any[] = [
    require("../../assets/images/successful.png"),
    require("../../assets/images/unpaid.png"),
    require("../../assets/images/awaitingAudit.png"),
  ]; //所有报名状态戳的src
  private statusImgSrc: string = ""; //当前报名状态戳的src
  private userAvatar: string = ""; //头像src
  private signUpTypeName: string = ""; 

  created() {
    this.current = new current();
    const { m } = this.$route.query;

    this.m = String(m);
    this.InitMeetingInfo();
    this.InitInfo();
    
  }
  mounted() {
    //对整个页面滚轮进行监听，每发生一次滚轮事件，执行一次方法
    window.addEventListener("scroll", this.initHeight);

    let _w = document.getElementsByClassName("personalCenter_main")[0] as HTMLElement;
    (this.$refs.welcomeWords as HTMLElement).style.width = _w.clientWidth + "px";

    // //对浏览器窗口大小触发事件进行监听
    window.onresize = () => {
      (this.$refs.welcomeWords as HTMLElement).style.width = _w.clientWidth + "px";
    };
  }
  /**
   * 日程模块时，左菜单做吸顶效果
   */
  initHeight() {
    //兼容性，获取页面滚动距离
    var scrollTop =
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    let _offsetTop = (document.getElementsByClassName("personalCenter_container")[0] as HTMLElement)
      .offsetTop;

    //判断滚动距离是否大于元素到顶端距离
    this.flags.is_fixed = scrollTop > _offsetTop ? true : false;
  }

  /**
   * @description: 获取会议基本信息
   */
  async InitMeetingInfo() {
    this.flags.showLoading = true;
    let params = {
      m: this.m,
    };
    let res = await IMeetingInfo.InitMeetingInfo(params);
    console.log("会议基本信息", res);
    if (res.Code === 1000) {
      this.headData = res;
      this.meetingTitle = " 欢迎您参加" + res.MeetingTitle;
    }

    // this.flags.showLoading = false;
  }

  async InitInfo() {
    this.flags.isLoading = true;
    let params = {
      m: this.m,
    };

    let res = await this.$http.personalCenter.InitSignUpSetUserConfig(params);
    console.log("总数据", res);

    if (res.Code === 1000) {
      let isSignPay = true;
      for (let i = 0; i < res.UserListEntity.length; i++) {
        if (res.UserListEntity[i].SignupStatusCode != 1) {
          isSignPay = false;
        }
      }
      let jump_link = this.$route.query.red == "no" ? "" : res.signUp_Set.jump_link;
      if (jump_link && isSignPay) {
        const { ch, channelId } = this.$route.query;
        let _url = channelId !== undefined ? channelId : ch;

        if (jump_link.indexOf("{channid}") !== -1) {
          jump_link = jump_link.replace("{channid}", _url);
        }
        if (jump_link.indexOf("userid") !== -1) {
          let _link = jump_link.replace("{userid}", res.CurrMuid);
          window.location.href = _link;
        } else {
          window.location.href = jump_link;
        }
        return;
      }
	  this.allow_update_info = res.signUp_Set.allow_update_info
	  console.log("allow_update_info", this.allow_update_info);
      this.orderData = res.OrderEntity;
      this.signDatas = this.current.cloneDeep(res.UserListEntity);
      this.memberdatas = this.current.cloneDeep(res.UserListEntity);
      this.memberdatas.shift();
      let { upload_payorder, iswrite_invoice } = res.signUp_Set;
      this.upload_payorder = upload_payorder;
      this.iswrite_invoice = iswrite_invoice;
      let { muid } = res.UserListEntity[0];
      this.GetSignMeetingUser(muid);

      // console.log("总个人数据", this.signDatas);
      this.statusImg(this.signDatas[0].SignupStatusCode);
      this.signUpTypeName = res.UserListEntity[0].SignUpTypeName
      if(this.$route.query.showTab){
        this.flags.showTab = this.$route.query.showTab
        if( this.flags.showTab == 3){
          this.subheading = "上传凭证"
          this.flags.showTab = 3
        }
      }
    }
    this.flags.isLoading = false;
  }
  getPaytypes(data: any){
    console.log(data)
    if( data >= 4 ){
      this.subheading = "上传凭证"
      this.flags.showTab = 3
    }
  }
  /**
   * @description:个人数据
   */
  async GetSignMeetingUser(muid: number) {
    let params = {
      m: this.m,
      muid,
    };
    let res = await this.$http.personalCenter.GetSignMeetingUser(params);
    console.log("团长个人数据", res);
    if (res.Code === 1000) {
      this.signupUserInfo = res;
      this.signupUserInfo.ssl_muid = muid;
      if (res.CurUserEntity) {
        console.log(res.CurUserEntity)
        let userAvatar = res.CurUserEntity.wx_photo;
        this.userAvatar = userAvatar;
        this.signupUserInfo.userAvatar = userAvatar;
        this.signupUserInfo.SignUpTypeName = this.signUpTypeName;
      }
      if (this.orderData) {
        this.signupUserInfo.orderData = this.orderData;
        this.signupUserInfo.orderData.ssl_muid = muid;
        this.signupUserInfo.orderData.ssl_m = this.m;
      }
    }
  }
  /**
   * @description:点击右侧菜单
   */
  handleShowTab(i: number, subheading: string) {
    this.flags.showTab = i;
    this.subheading = subheading;
  }
  /**
   * @description:返回不同的状态码显示不同的状态图片
   */
  statusImg(code: number) {
    switch (code) {
      case 1:
        this.statusImgSrc = this.statusImgSrcList[0];
        break;
      case 2:
        this.statusImgSrc = this.statusImgSrcList[1];
        break;
      default:
        this.statusImgSrc = this.statusImgSrcList[2];
        break;
    }
  }
}
